import { render, staticRenderFns } from "./expedientPRL.vue?vue&type=template&id=68c4ad94&"
import script from "./expedientPRL.vue?vue&type=script&lang=js&"
export * from "./expedientPRL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports